import { z } from 'zod'

// the per-account "default tab" — the sub-nav view an account card / bare account URL opens.
// these values are the route path segments under /investments/:connectionId/:accountId. only
// tabs that can be an account's landing tab are listed: the always-on tabs plus the two bot
// tabs (backtest and settings are deliberately excluded as landing targets).
export const INVESTMENT_DEFAULT_TAB_VALUES = [
  'portfolio',
  'operations',
  'orders',
  'payments',
  'rebalancing',
  'ofz-screener',
  'bot',
  'day-trade-bot',
] as const

export const investmentDefaultTabSchema = z.enum(INVESTMENT_DEFAULT_TAB_VALUES)

export type InvestmentDefaultTab = z.infer<typeof investmentDefaultTabSchema>

// portfolio preserves the historical behavior (cards always opened Portfolio) and is the
// fallback whenever a stored default is no longer available.
export const DEFAULT_INVESTMENT_TAB: InvestmentDefaultTab = 'portfolio'

// request body for setting an account's default tab, and the response shape echoed back.
export const brokerAccountDefaultTabSchema = z.object({
  defaultTab: investmentDefaultTabSchema,
})

export type BrokerAccountDefaultTabDto = z.infer<typeof brokerAccountDefaultTabSchema>
